// @flow

// Libs

// Effect Managers
import { all, call, fork, select } from 'redux-saga/effects'

// Controller
import controller from 'fc-ctrl-assets'

// Constants
import {
  MANAGEMENT_ZONES,
  FIELD,
} from 'fc-model-assets/src/constants'

// Selectors
import { firstAvailableGrowerId$ } from 'fc-assets'
import selectedSeasonId$ from 'hfty-seasons/src/selectors/selectedSeasonId'

// Sagas
import watchUpdateFarm from './updateFarm'
import watchEnvironmentReceived from './watchEnvironmentReceived'

export default function *main (): Generator<*, *, *> {
  yield call(controller.start)
  yield fork(controller.watch)
  yield fork(watchUpdateFarm)
  yield fork(watchEnvironmentReceived)

  yield call(controller.read, {
    queryParams: {
      shape: 'True',
      toFarmsOnly: 'True',
    },
  })
  const rootAsset = yield select(firstAvailableGrowerId$)
  const season = yield select(selectedSeasonId$)
  yield all([
    call(controller.read, {
      queryParams: {
        shape: 'True',
        category: FIELD,
        rootAsset,
        season,
      },
    }),
    call(controller.read, {
      queryParams: {
        category: MANAGEMENT_ZONES,
        rootAsset,
        season,
      },
    }),
  ])
}
